import { Untyped } from "./Untyped";
export class Typed {
    type;
    backend;
    get options() {
        return this.backend.options;
    }
    set options(value) {
        this.backend.options = value;
    }
    constructor(type, options = {}) {
        this.type = type;
        this.backend = new Untyped(options);
    }
    parse(data) {
        return this.type.get(this.backend.parse(data));
    }
    stringify(data) {
        return this.backend.stringify(data);
    }
}
//# sourceMappingURL=Typed.js.map